import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dropbox-list-file',
  templateUrl: './dropbox-list-file.component.html',
  styleUrls: ['./dropbox-list-file.component.css']
})
export class DropboxListFileComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }




  requestData = 
  `
  curl 'https://api.optimusdrive.ai/v1/dropbox/files?path=/videos_for_upscaling' \
  -H 'authorization: XXX'
  
  `

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }






  sucessData = `
  {
    "data": {
        "entries": [
            {
                ".tag": "file",
                "name": “abc_270p_Original.mp4","path_lower": "/videos_for_upscaling/abc_270p_original.mp4","path_display": "/Videos_for_Upscaling/abc_270p_Original.mp4","id": "id:QsNRbadAAAAAAFA",
                "client_modified": "2023-04-24T09:46:51Z",
                "server_modified": "2023-04-24T09:46:51Z",
                "rev": "5fa11e2efd02d371",
                "size": 1269118,
                "is_downloadable": true,
                "content_hash": "16b6d928ad22fa1b43a35f647d62d85d8799e13a8f1175273cc"
            },
            {
                ".tag": "file",
                "name": "elcorte_270p_Original.mp4",
                "path_lower": "/videos_for_upscaling/elcorte_270p_original.mp4",
                "path_display": "/Videos_for_Upscaling/elcorte_270p_Original.mp4",
                "id": "id:QsNRbaS2CyfAAAAFQ",
                "client_modified": "2023-04-24T09:48:19Z",
                "server_modified": "2023-04-24T09:48:19Z",
                "rev": "5fa11e822f1f02d371",
                "size": 5503971,
                "is_downloadable": true,
                "content_hash": "3f69d7564d6ae47fd34585d36f0"
            }
        ],
        "cursor": "AAfdDxkOqpoHsu_RUy5hkyPlDOtUSmImJtvfdwPJb1oSEquhiIc",
        "has_more": false
    },
    "message": "Files fetched successfully"
}


`

  Error5x = `
  {
    "error": {},
    "message": "string"
  }
  `

  Error401x = `
  {
    "error": {},
    "message": "Unauthorized"
  }
  `
  Error4x = `
  {
    "error": "unable to generate token",
    "message": "Something went wrong!"
  }`


}
